__turbopack_context__.v({
  "content": "Accordion-module__rDJ0ca__content",
  "item": "Accordion-module__rDJ0ca__item",
  "root": "Accordion-module__rDJ0ca__root",
  "trigger": "Accordion-module__rDJ0ca__trigger",
});
